import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { Alert } from "../../../../../theme/Component/Alert";
import { BasicMultiSelectTable } from "../../../../../theme/Component/BasicMultiSelecTable";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const AOP002 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLInvoice);

    useEffect(() => {
        const data = configProcedure?._pocessData?.Props;
        if (data) {
            setProps(data)
            if (data.Mnemonic && data.Consecutive) {
                instance.getUblInvoiceCatalog12(null, null, null, new Date(data.DocumentDate).getFullYear(), null, null, null, data.Mnemonic, data.IDDocument, data.DocumentDate, null, null).then(
                    (resp) => {
                        resp.List.forEach((user) => {
                            user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                            user.DataBeanProperties.Doc = `${user.DataBeanProperties.FCIDDocument ? `${user.DataBeanProperties.FCMnemonic ?? ""} - ${user.DataBeanProperties.FCConsecutive ?? ""} - ${user.DataBeanProperties.FCDate ?? ""}` : "N/A"}`
                            user.DataBeanProperties.Remision = `${user.DataBeanProperties.EAFConsecutive ? `${user.DataBeanProperties.EAFMnemonic ?? ""} - ${user.DataBeanProperties.EAFConsecutive ?? ""} - ${user.DataBeanProperties.EAFDate ?? ""}` : "N/A"}`
                            user.DataBeanProperties.Obligation = `${user.DataBeanProperties.OBConsecutive ? `${user.DataBeanProperties.OBMnemonic ?? ""} - ${user.DataBeanProperties.OBConsecutive ?? ""} - ${user.DataBeanProperties.OBDate ?? ""}` : "N/A"}`
                        });
                        setLista(resp.List);
                    }
                ).catch(err => { toast.error("No se pudo realizar la consulta") })
            }
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        const resumen = listaResult.map((causa, index) => {
            const item = causa.DataBeanProperties;
            return `${index + 1}. ${item.FCMnemonic ?? ""} - ${item.FCConsecutive ?? ""} - ${item.FCDate ?? ""}`;
        }).join("; ");

        const propsList = listaResult.map(causa => {
            const item = causa.DataBeanProperties;
            return {
                Consecutive: item.FCConsecutive,
                IDDocument: item.FCIDDocument,
                Mnemonic: item.FCMnemonic,
                DocumentDate: item.FCDate,
            };
        });

        if (configProcedure?._pushInfo) {
            configProcedure._pushInfo(
                _single.jsonToBootstrapTable({
                    "Causaciones": resumen || "Sin información"
                })
            );
        }

        if (configProcedure?._pushProps) {
            configProcedure._pushProps({ Causaciones: JSON.stringify(propsList) });
        }

        if (configProcedure?._exportMap) {
            configProcedure._exportMap({ Causaciones: propsList });
        }
    };

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (!listaResult || listaResult.length === 0) {
            toast.error("Debe seleccionar al menos una causación");
            return;
        }

        const invalids = validateForm(listaResult);

        if (invalids.length > 0) {
            invalids.forEach(({ id, missing }) => {
                toast.error(`Factura ${id ?? "sin ID"} incompleta. Campos faltantes: ${missing.join(", ")}`);
            });
            return;
        }

        onExportMap();
    };

    const validateForm = (dataList: any[]) => {
        const requiredFields = ["FCIDDocument", "FCMnemonic", "FCConsecutive", "FCDate"];
        const invalidItems: { id: string | number; missing: string[] }[] = [];

        dataList.forEach((causaciones, index) => {
            const item = causaciones.DataBeanProperties;
            const missing: string[] = [];

            requiredFields.forEach(field => {
                if (item[field] === null || item[field] === undefined || item[field] === "") {
                    missing.push(field);
                }
            });

            if (missing.length > 0) {
                const id =
                    item.IDUBLInvoice ??
                    item.InvoiceID ??
                    item.IDUBLInvoice ??
                    item.FCConsecutive ??
                    `#${index + 1}`;
                invalidItems.push({ id, missing });
            }
        });

        setMissingFields(invalidItems.flatMap(i => i.missing));
        return invalidItems;
    };

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Nit-Cliente', property: 'Client', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
    ]

    const [listaResult, setListaResult] = useState<any>([]);

    return (
        <div className="row">
            <div className="col-md-12">
                {lista.length > 0 ?
                    <BasicMultiSelectTable
                        keyId="IDUblInvoice"
                        clearnotListBody
                        setRowBean={setBean}
                        body={lista}
                        bodyResult={listaResult}
                        head={head}
                        updateValues={({ bodyResult }) => { setListaResult(bodyResult) }}
                    />
                    :
                    <Alert children={`No se encontro facturas asociadas`} clase="info" />
                }
            </div>
            <div className="col-md-6">
                <BasicButton eventClick={() => { validateData() }} icon="ri-send-plane-line" children={`Seleccionar Causación`} useMargin />
            </div>
        </div>
    );
}